import StepId from "@/model/progress/StepId"
const providerKey = "aff_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "affResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: `/providers/${providerKey}/approved`,
        },
        {
            name: "affPrequalifyStart",
            path: `/providers/${providerKey}/modes/prequalify/start`,
            redirect: `/providers/${providerKey}/prequalified`,
        },
        {
            name: "affPrequalifyTerms",
            meta: { step: StepId.PAYMENT_OPTIONS },
            path: `/providers/${providerKey}/terms`,
            component: () => import(/* webpackChunkName:"aff" */ "@/views/provider/aff/AffTermsView.vue"),
        },

        {
            name: "affPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/aff/AffPaymentPlanReviewView.vue"),
        },
        {
            name: "affPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/apply/CheckWisconsinView.vue"),
        },
        {
            name: "affCheckWisconsinNext",
            path: `/providers/${providerKey}/checkWisconsinNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/checkCalifornia`,
        },
        {
            name: "affCheckCaliforniaNext",
            path: `/providers/${providerKey}/checkCaliforniaNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/terms`,
        },
        {
            path: `/providers/${providerKey}/terms`,
            name: "affTerms",
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/aff/AffTermsView.vue"),
        },
        {
            name: "affApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/aff/AffApprovedView.vue"),
        },
        {
            name: "affAgreement",
            path: `/providers/${providerKey}/agreement`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/aff/AffIframeView.vue"),
        },
        {
            name: "affComplete",
            path: `/providers/${providerKey}/complete`,
            meta: { step: StepId.COMPLETE },
            component: () => import("@/views/provider/aff/AffCompleteView.vue"),
        },
        {
            name: "affCorrectError",
            path: `/providers/${providerKey}/correctErrors`,
            extends: "correctErrors",
            component: () => import("@/views/provider/aff/AffCorrectErrorsView.vue"),
            props: route => ({ applicantType: route.query.applicantType }),
        },
        {
            name: "affDeclined",
            path: `/providers/${providerKey}/declined`,
            meta: { step: StepId.COMPLETE, stepper: false },
            component: () => import("@/views/provider/aff/AffDeclinedView.vue"),
        },
    ],
}
